import {Component, Injectable} from '@angular/core';
import {
    MatLegacySnackBar as MatSnackBar,
    MatLegacySnackBarConfig as MatSnackBarConfig,
    MatLegacySnackBarDismiss as MatSnackBarDismiss,
    MatLegacySnackBarRef as MatSnackBarRef
} from '@angular/material/legacy-snack-bar';

import {MESSAGES} from '@app/core/model/messages';
import {TestConnectionSnackbarComponent} from '@app/views/admin/application-settings/components/delivery-config/test-connection/test-connection-snackbar/test-connection-snackbar.component';
import {BehaviorSubject, Subject} from 'rxjs';

@Injectable()
export class SnackBarService {

    constructor(private _snackBar: MatSnackBar) {
    }

    public get snackBar(): MatSnackBar {
        return this._snackBar;
    }

    public showSnackBarMessage(message: string = MESSAGES.SAVED, duration: number = 3000, action: string = '') {
        if (this.snackBar._openedSnackBarRef && this.snackBar._openedSnackBarRef.instance) {
            this.snackBar._openedSnackBarRef.afterDismissed().subscribe((matSnackBarDismiss: MatSnackBarDismiss) => {
                this.snackBar.open(message, '', <MatSnackBarConfig>{duration: duration});
            });
        } else {
            this.snackBar.open(message, '', <MatSnackBarConfig>{duration: duration});
        }
    }

    public onOpenFromComponent(duration: number = 3000, component: Component | any, componentData: any): Subject<MatSnackBarRef<any>> {
        const snackBarRef$ = new BehaviorSubject<MatSnackBarRef<any>>(null);
        if (this.snackBar._openedSnackBarRef && this.snackBar._openedSnackBarRef.instance) {
            this.snackBar._openedSnackBarRef.afterDismissed().subscribe((matSnackBarDismiss: MatSnackBarDismiss) => {
                const snackBarRef = this.openFromComponent(duration, componentData);
                snackBarRef$.next(snackBarRef);
            });
        } else {
            const snackBarRef = this.openFromComponent(duration, componentData);
            snackBarRef$.next(snackBarRef);
        }

        return snackBarRef$;
    }

    private openFromComponent(duration: number, componentData: any): MatSnackBarRef<any> {
        return this.snackBar.openFromComponent(TestConnectionSnackbarComponent, {
            duration: duration,
            data: componentData
        });
    }
}
